import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusBtnClass',
})
export class StatusBtnClassPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'started':
        return 'btn-warning';
      case 'official':
        return 'btn-danger';
      case 'open':
        return 'btn-success';
      case 'closed':
        return 'btn-dark';
      case 'temporary':
        return 'btn-temporary';
      case 'abandoned':
        return 'btn-abandoned';
      default:
        return '';
    }
  }
}
